import { useSearchParams } from "react-router-dom";
import { IntegrityPanel } from "@/components/invoices/IntegrityPanel";
import { BankAccountsPanel } from "@/components/settings/BankAccountsPanel";
import { BucketsPanel } from "@/components/settings/BucketsPanel";
import { CategoriesPanel } from "@/components/settings/CategoriesPanel";
import { CompanyPanel } from "@/components/settings/CompanyPanel";
import { DirectorsPanel } from "@/components/settings/DirectorsPanel";
import { DrivePanel } from "@/components/settings/DrivePanel";
import { LutPanel } from "@/components/settings/LutPanel";
import { PasswordPanel } from "@/components/settings/PasswordPanel";
import { PageHeader } from "@/components/ui/page-header";
import { TabPanel, Tabs, pickTab, type TabItem } from "@/components/ui/tabs";

const TABS = [
  "company",
  "banks",
  "buckets",
  "categories",
  "drive",
  "lut",
  "numbering",
  "directors",
  "password",
] as const;
type SettingsTab = (typeof TABS)[number];
const TAB_ITEMS: TabItem<SettingsTab>[] = [
  { id: "company", label: "Company" },
  { id: "banks", label: "Bank accounts" },
  { id: "buckets", label: "Buckets" },
  { id: "categories", label: "Categories" },
  { id: "drive", label: "Google Drive" },
  { id: "lut", label: "LUT" },
  { id: "numbering", label: "Numbering" },
  { id: "directors", label: "Directors" },
  { id: "password", label: "My password" },
];

export function SettingsPage() {
  const [params, setParams] = useSearchParams();
  const tab = pickTab(params.get("tab"), TABS, "company");

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Settings"
        description="Company details printed on invoices, bank accounts, LUT and director logins."
      />
      <div>
        <Tabs
          label="Settings sections"
          items={TAB_ITEMS}
          value={tab}
          onChange={(next) => setParams(next === "company" ? {} : { tab: next }, { replace: true })}
        />
        <TabPanel id={tab}>
          {tab === "company" && <CompanyPanel />}
          {tab === "banks" && <BankAccountsPanel />}
          {tab === "buckets" && <BucketsPanel />}
          {tab === "categories" && <CategoriesPanel />}
          {tab === "drive" && <DrivePanel />}
          {tab === "lut" && <LutPanel />}
          {tab === "numbering" && <IntegrityPanel />}
          {tab === "directors" && <DirectorsPanel />}
          {tab === "password" && <PasswordPanel />}
        </TabPanel>
      </div>
    </div>
  );
}
